<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0003 29.3327C23.3643 29.3327 29.3337 23.3633 29.3337 15.9993C29.3337 8.63535 23.3643 2.66602 16.0003 2.66602C8.63633 2.66602 2.66699 8.63535 2.66699 15.9993C2.66699 18.4273 3.31633 20.706 4.45099 22.666L3.33366 28.666L9.33366 27.5487C11.3597 28.7208 13.6597 29.3362 16.0003 29.3327Z"
      stroke="#009E50"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
